import { Component, OnInit } from '@angular/core';
import { SDKErrorResponse } from 'src/app/models/sdk-error-response.model';
import { SDKResponse } from 'src/app/models/sdk-response.model';
import { AppStateService } from 'src/app/services/app-state.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  origin: string;
  responseResult: SDKResponse | SDKErrorResponse | null;

  constructor(private appState: AppStateService) { }

  async ngOnInit(): Promise<void> {
    let promise = await Promise.all([this.getOrigin(), this.getSDKResponse()]);

    this.origin = promise[0];
    this.responseResult = promise[1];

    // Listener de comunicação externa autorizada
    window.addEventListener('message', (event) => { /* console.log(event, 1); */ });

    // Listener para informar ao window pai que estou sendo fechado
    window.addEventListener('beforeunload', (e) => {
      // e.preventDefault();
      // e.returnValue = '';
      this.close();
    });
  }

  getOrigin(): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        this.appState.getOrigin.subscribe(origin => {
          if (origin) {
            resolve(origin);
          }
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  getSDKResponse(): Promise<SDKResponse | SDKErrorResponse | null> {
    return new Promise((resolve, reject) => {
      try {
        this.appState.getSDKResponse.subscribe(result => {
          if (result) {
            resolve(result);
          }
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  close() {
    const evento = { success: true, close: true, response: this.responseResult, };
    window.opener.postMessage(evento, this.origin);
  }

}
